// extracted by mini-css-extract-plugin
export default {"instrumentStatusCallout":"instrumentStatusCallout-JL6NN","label":"label-uUKle","callout":"callout-kRAaS"};